import React from "react";
import { Card, CardContent, CardTitle } from "@ui/card";
import { SVG } from "@components/items/common/SVG";
import TranslatedText from "./TranslatedText";
import { getPublicMediaUrl } from "@modules/api/util/mediaHelper";
import PlaylistMenu from "@components/layouts/b2c/my-corner/PlaylistMenu";
import { Server } from "@modules/api";

interface PlaylistCardProps {
  item: Server.PlaylistOutput | null;
  onClick?: () => void;
}

const PlaylistCard = ({ item, onClick }: PlaylistCardProps) => {
  return (
    <Card
      className="cursor-pointer gap-3 border-none p-4 dark:bg-[#434449]"
      onClick={onClick}
    >
      <CardContent className="w-[200px] space-y-2 p-0">
        {item?.picture ? (
          <img
            src={getPublicMediaUrl(item?.picture)}
            alt="No item"
            className="h-[200px] w-[200px] rounded-lg"
          />
        ) : (
          <div className="flex h-[200px] w-[200px] items-center justify-center rounded-lg bg-[#9999992B]/15 p-6">
            <SVG src="/assets/icons/empty-playlist.svg" />
          </div>
        )}
      </CardContent>
      <div className="flex items-center justify-between">
        <CardTitle className="flex w-2/3 max-w-[100px] flex-col flex-wrap items-start justify-center gap-3 py-3">
          <div className="flex items-center justify-start text-[20px] font-medium dark:text-white">
            {item?.title}
          </div>
          <div className="flex items-center justify-start gap-1 text-[16px] font-normal text-[#898A8D]">
            {renderTitlesCount(item?.itemCount)}
          </div>
        </CardTitle>
        <PlaylistMenu item={item} />
      </div>
    </Card>
  );
};

export default PlaylistCard;

const renderTitlesCount = (count: number | undefined) => {
  if (count == null || count === 0)
    return <TranslatedText text={`my-library.${"no titles"}`} />;

  if (count === 1) return <TranslatedText text={`my-library.${"title"}`} />;
  if (count === 2)
    return <TranslatedText text={`my-library.${"two titles"}`} />;
  if (count <= 10)
    return (
      <>
        <div>{count}</div>
        <TranslatedText text={`my-library.${"titles"}`} />
      </>
    );
  if (count > 10)
    return (
      <>
        <div>{count}</div>
        <TranslatedText text={`my-library.${"title"}`} />
      </>
    );

  return "";
};
